import React, {useEffect, useState} from 'react';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";
import {Redirect} from "react-router-dom";
import StudentReportRow from "./StudentReportRow";
import Button from "reactstrap/lib/Button";
import {report_strings} from "../../translations/report_translations";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);
let reportStrings = new LocalizedStrings(report_strings);

const StudentReport = (props) => {
    const [clientId, setClientId] = useState(null);
    const [yclassId, setYclassId] = useState(null);

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
    }

    localize();

    function renderTableData() {
        if (props.data !== null) {
            return props.data.map((studentData, index) => {
                return (
                    <StudentReportRow student={studentData.student}
                                      key={studentData.student.id.toString() + index.toString()}
                                      yclasses={studentData.yclasses}
                                      strings={resourceStrings} goToStudent={goToStudent} goToClass={goToClass}/>
                )
            })
        }
    }

    function goToStudent(id) {
        setClientId(id)
    }

    function goToClass(id) {
        setYclassId(id)
    }

    if (clientId) {
        return <Redirect from="*" to={{
            pathname: "/admin/student-profile",
            state: {
                clientId: clientId,
                backToUnpaidReport: true
            }
        }}/>
    }

    if (yclassId) {
        return <Redirect from="*" to={{
            pathname: "/admin/class_overview",
            state: {backToUnpaidReport: true, yclassId: yclassId}
        }}/>
    }

    return (
        <div style={{width: "100%", margin: 20}}>
            <div style={{display: "flex", flexFlow: "row", alignItems: "center", justifyContent: "left"}}>
                <Button onClick={e => props.onRangeUpdated(e, "week")} color={(!props.rangeType || props.rangeType == "week") ? "success": "secondary"}>{reportStrings.last7Days}</Button>
                <Button onClick={e => props.onRangeUpdated(e, "cur_month")} color={props.rangeType == "cur_month" ? "success": "secondary"}>{commonStrings.cur_month}</Button>
                <Button onClick={e => props.onRangeUpdated(e, "last_month")} color={props.rangeType == "last_month" ? "success": "secondary"}>{reportStrings.last_month}</Button>
            </div>
            <div style={{marginTop: 20}}>
                {renderTableData()}
            </div>
        </div>
    );
};

export default StudentReport;